<style lang="scss" scoped>
    .table {
        width: 100%;
        border-spacing: 0px 10px;
        &:before {
            display: none !important;
        }
    }
</style>
<template>
    <div style="min-height: 500px">
        <div class="textRight">
            <DatePicker type="daterange" split-panels placeholder="选择日期" style="width: 200px" @on-change="selectTime"></DatePicker>
            <Button type="primary" class="m-l-20" @click="getTable">搜索</Button>
        </div>
        <table class="ivu-table table m-t-10" cellspacing="0" cellpadding="0">
            <tr>
                <th>
                    <span class="ivu-table-cell">遥信项</span>
                </th>
                <th>
                    <span class="ivu-table-cell">状态</span>
                </th>
                <th>
                    <span class="ivu-table-cell">变化时间</span>
                </th>
            </tr>
            <tr v-for="(item, index) in statusData" :key="index">
                <th>
                    <span class="ivu-table-cell">{{item.pointName}}</span>
                </th>
                <th>
                    <span class="ivu-table-cell">{{item.state == 1 ? '在线' : '离线'}}</span>
                </th>
                <th>
                    <span class="ivu-table-cell">{{item.valueTime}}</span>
                </th>
            </tr>
        </table>
    </div>
</template>
<script>
    import { getDate } from '@/assets/js/index.js';
    // 随机字符串
import getRandVal, {getTime} from '@/assets/js/index';
// 加密
import Base64 from '@/assets/js/base64.js';
import md5 from 'js-md5';
    export default {
        name: 'wit-electric-state',
        props: {
            id: '',
        },
        data() {
            return {
                beginTime: '',
                endTime: '',
                statusData: [],
                loginData: {},
            };
        },
        mounted() {
            this.getTable();
            this.loginData = JSON.parse(window.localStorage.getItem('loginData'));
        },
        methods: {
             //获取数据开始
    getPwdHash(pwd, data) {
        var sha = md5(pwd + data);
        var base = new Base64();
        var pwdHashStr = base.encode(sha);
        return pwdHashStr;
    },
            getTable() {
                return new Promise((resolve, reject) => {
                    let url = `/mcbw/network_monitor/pointNowValue/${this.id}`;
                    let _this = this;
                    var data = {
                        type: 'get',
                        url: url,
                        obj: {
                            orgId: _this.$store.state.baseInfoLayer.baseInfoId,
                            type: 'zt',
                            beginTime: this.beginTime,
                            endTime: this.endTime,
                        }
                    };
                    _this.$Axios(data).then((res) => {
                        if (res && res.data.data.length) {
                            for(let i = 0;i < res.data.data.length; i++){
                                res.data.data[i].valueTime = (res.data.data[i].valueTime == '~' ? '~' : getDate(Number(res.data.data[i].valueTime), 'year'));
                            }
                            this.statusData = res.data.data;
                        }
                        resolve()
                    }).catch(err => {
                        reject(err)
                    })
                })
            },
            selectTime(value) {
                this.beginTime = value[0] || undefined;
                this.endTime = value[1] || undefined;
            }//日期选择
        },
        watch: {
            id() {
                this.getTable()
            }
        },
        components: {}
    };
</script>


// WEBPACK FOOTER //
// src/components/wit-electric-monitor/wit-electric-status.vue